import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=c1b127c8&scoped=true&"
import script from "./DashboardSection.vue?vue&type=script&lang=js&"
export * from "./DashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=c1b127c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b127c8",
  null
  
)

export default component.exports